// extracted by mini-css-extract-plugin
export default {"container":"SortOrderColumn_container__W5E8g","sortOrderButton":"SortOrderColumn_sortOrderButton__pcgVU"};